<template>
  <ElDropdown
    class="locale-dropdown"
    :hide-on-click="false"
    trigger="click"
    @command="changeLanguage"
  >
    <div class="el-dropdown-link">
      <i class="material-icons">language</i>
      {{ lang.toUpperCase() }}
      <i class="el-icon-arrow-down" />
    </div>
    <ElDropdownMenu slot="dropdown">
      <ElDropdownItem
        v-for="lang in filteredLanguages"
        :key="lang"
        :command="lang"
        class="locale-dropdown__item"
      >
        {{ lang.toUpperCase() }}
      </ElDropdownItem>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import lang from '@/mixins/lang';
import { LANGUAGE, AVAILABLE_LANGUAGES } from '@/store/types';

export default {
  name: 'LocalDropdown',
  mixins: [lang],
  computed: {
    ...mapGetters({
      languages: AVAILABLE_LANGUAGES,
    }),
    filteredLanguages() {
      return this.languages.filter(lang => lang !== this.lang);
    },
  },
  methods: {
    ...mapActions({
      setLanguage: LANGUAGE,
    }),
    changeLanguage(language) {
      this.setLanguage(language);
    },
  },
};
</script>

<style lang="scss">
.locale-dropdown {
  color: $white !important;
  font-size: $lb-side-nav-font-size !important;

  &:hover {
    cursor: pointer;
  }
}
</style>
